import axios from "@/axios";

export const namespaced = true

export const state = {
    tooltips : [],
    editable: false
}


export const getters = {
  tooltips: function (state) { return state.tooltips},
  editable: function (state){return state.editable}
  };

export const mutations = {
  SET_TOOLTIP: (state, response) => (state.tooltips = response),
  SET_EDITABLE:(state , value)=> (state.editable = value)
}

export const actions = {
  async getToolTips({ commit }) {                                                                                                                                                             
    await axios.get("/api/tooltips/all").then((res) => {
      if (res.data.length > 0) {
        let tooltips = res.data
        .map((row) => {
          
          return {
            ...row,
            editMode: false,
          };   
                                                                                                         
        });
    commit("SET_TOOLTIP", tooltips );
  }else {
    // No Tooltips found.
    commit("SET_TOOLTIP", []);
  }
})
.catch((err) => {
  console.log(err); //not handelled
});
},  
async saveTooltip({ state }, tooltip) {
    // const tooltipNew = {
    //   "name" : tooltip.name,
    //   "description" : tooltip.description,
    //   "status": tooltip.status
    // }
    return await axios.post("/api/tooltips", tooltip);
  },
  async deleteTooltip({ dispatch }, row) {
    let response = ""
    await axios
      .get("/api/tooltips/" + row.id)
      .then(async(res) => {
        response = res
        if(response.data.status){
          let tooltip = response.data
          tooltip.status = false
          await axios.post('/api/tooltips', tooltip).then((res)=> res)
        }else{
          let tooltip = response.data
          tooltip.status = true
          await axios.post('/api/tooltips', tooltip).then((res)=> res)
        }
        dispatch("getToolTips");
      })
      .catch((err) => {
        response = err
      });

    return response;
  },
  async editableValue({commit }){
    if(state.editable){
      commit("SET_EDITABLE", false ); 
    }else{
      commit("SET_EDITABLE", true ); 
    }
  }
}

